import type { ReactElement } from 'react';

import { rangeProblem } from '../presentation';
import type { TimeStudyFilters } from '../types';
import { AnalysisFilters } from './AnalysisFilters';
import { AverageByTypeCard } from './AverageByTypeCard';
import { AxisDeviationCard } from './AxisDeviationCard';
import { ComplianceCard } from './ComplianceCard';
import { KpiTiles } from './KpiTiles';
import { MyStagesCard } from './MyStagesCard';
import { ReworkCard } from './ReworkCard';
import { StageVsStandardCard } from './StageVsStandardCard';
import { ThroughputCard } from './ThroughputCard';

// Pestaña Análisis de Estudio de tiempos (so=420, spec §4.2): filtros, indicadores y
// las tarjetas que el usuario puede ver según sus permisos.

export interface AnalysisPermissions {
  deviation: boolean;
  rework: boolean;
  myStages: boolean;
  catalogs: boolean;
}

interface Props {
  filters: TimeStudyFilters;
  companyId: string;
  can: AnalysisPermissions;
  onChange: (patch: Partial<TimeStudyFilters>) => void;
  /** Presente solo si hay filtros distintos del defecto (G1-6). */
  onClear?: () => void;
}

export function AnalysisTab({ filters, companyId, can, onChange, onClear }: Props): ReactElement {
  const problem = rangeProblem(filters);
  return (
    <>
      <AnalysisFilters
        filters={filters}
        companyId={companyId}
        canFilterCatalogs={can.catalogs}
        onChange={onChange}
        onClear={onClear}
      />
      {problem !== null && (
        <p className="fld-err rangeerr" role="alert">
          {problem}
        </p>
      )}
      <KpiTiles
        filters={filters}
        companyId={companyId}
        canDeviation={can.deviation}
        canRework={can.rework}
      />
      <div className="tsgrid">
        {can.myStages && <MyStagesCard companyId={companyId} />}
        {can.deviation && <StageVsStandardCard filters={filters} companyId={companyId} />}
        {can.deviation && <AverageByTypeCard filters={filters} companyId={companyId} />}
        {can.rework && <ReworkCard filters={filters} companyId={companyId} />}
        {can.deviation && (
          <AxisDeviationCard
            filters={filters}
            companyId={companyId}
            onAxisChange={(eje) => onChange({ eje })}
          />
        )}
        {can.deviation && (
          <ThroughputCard
            filters={filters}
            companyId={companyId}
            onGranularityChange={(gran) => onChange({ gran })}
          />
        )}
      </div>
      {can.deviation && (
        <ComplianceCard
          filters={filters}
          companyId={companyId}
          onViewChange={(cumpl) => onChange({ cumpl })}
        />
      )}
    </>
  );
}
